export enum FirebaseRefs {
  USERS = "users",
  INITIAL_DETAILS = "initial_details",
  AI_CHAT_STEP1 = "ai_chat_step1",
  Initial_Details_Step1_Thread_Mapping = "initial_details_step1_thread_mapping",
  ConsentOrders = "consent_orders",
  ASSETS = "assets",
  DEBTS = "debts"
}
